import type { WhitepaperSection } from '@wtta/scoring'

interface WhitepaperSectionsProps {
  sections: WhitepaperSection[]
}

export function WhitepaperSections({ sections }: WhitepaperSectionsProps) {
  if (sections.length === 0) return null

  return (
    <section
      className="report-section whitepaper"
      data-testid="whitepaper-sections"
    >
      {sections.map((section) => (
        <article
          key={section.id}
          className="whitepaper__article"
          data-testid={`whitepaper-${section.id}`}
        >
          <h2 className="report-section__title">{section.title}</h2>
          <p className="whitepaper__lead">{section.lead}</p>
          {section.paragraphs.map((paragraph, index) => (
            <p
              key={`${section.id}-p${index}`}
              className="whitepaper__paragraph"
            >
              {paragraph}
            </p>
          ))}
        </article>
      ))}
    </section>
  )
}
